export const acTypes = {
    loading: "LOADING_AC",
    delete: "DELETE_AC",
    loadedOne: "LOADED_AC",
    loadedMultiple: "LOADED_ACS",
    success: "SUCCESS_AC",
    restore: "RESTORE_AC",
    hardDelete: "HARDDELETE_AC",
};
